import * as React from 'react';
import { connect } from 'react-redux';
import { ModalWindow } from '@cian/ui-kit/modal';

import { IConfig } from '../../types/config';
import { ERegionsStatus, IRegions, IRegionsItem } from '../../types/regions';
import { Header, Tabs, List } from '../../components/GeoSwitcher';
import { updateRegion, toggleRegions } from '../../reducers/modules/config/config';
import { TDispatch } from '../../types/redux';

interface IProps {
  config: IConfig;
  /** Коллекция регионов */
  regions: IRegions;
  dispatch: TDispatch;
}

const fakeRegion: IRegionsItem = { displayName: 'Вся Россия', id: 0 };

function buildRegionsList(items: IRegionsItem[]): IRegionsItem[] {
  if (items.length > 0 && items[0].id === 0) {
    return items.slice(1);
  }
  return items;
}

const RegionsComponent: React.FC<IProps> = ({ config, regions, dispatch }) => {
  const [inputValue, setInputValue] = React.useState('');
  const [currentRegion, setCurrentRegion] = React.useState<IRegionsItem>(
    regions.items.find(region => region.id === Number(config.regionID)) || fakeRegion,
  );
  const [regionsList, setRegionsList] = React.useState<IRegionsItem[]>(() =>
    buildRegionsList(regions.items),
  );

  React.useEffect(() => {
    if (config.regionsShown) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [config.regionsShown]);

  React.useEffect(() => {
    setRegionsList(buildRegionsList(regions.items));
  }, [regions.items]);

  if (!config.regionsShown) {
    return null;
  }

  /** Возвращает список регионов по части названия */
  const getSuggests = (): IRegionsItem[] => {
    const regex = new RegExp(inputValue, 'i');
    return regionsList.filter(region => regex.test(region.displayName));
  };

  /** Возвращает список регионов для табов */
  const getTabsRegions = (): IRegionsItem[] => {
    const tabs: IRegionsItem[] = [fakeRegion];
    const moscow = regionsList.find(region => region.id === 1);
    const spb = regionsList.find(region => region.id === 2);

    if (moscow) {
      tabs.push({ ...moscow, displayName: 'Москва и МО' });
    }
    if (spb) {
      tabs.push({ ...spb, displayName: 'Санкт-Петербург и ЛО' });
    }

    return tabs;
  };

  /** Сохраняет объект региона */
  const handleSelectRegion = (region: IRegionsItem) => {
    setInputValue(region.displayName);
    setCurrentRegion(region);
  };

  /** Устанавливает и запоминает в куке новый регион */
  const handleSubmitRegion = () => {
    if (!currentRegion) {
      dispatch(toggleRegions(false));
      return;
    }

    const { id, displayName, baseHost, mainTownId } = currentRegion;

    if (id === Number(config.regionID)) {
      dispatch(toggleRegions(false));
      return;
    }

    dispatch(updateRegion(String(id), displayName));
    dispatch(toggleRegions(false));

    const { location } = document;
    const path = location.pathname + location.search + location.hash;

    if (baseHost) {
      document.cookie = `content_is_russia=0;path=/;domain=.cian.ru;`;

      if (baseHost.includes('www')) {
        document.cookie = `session_region_id=${id || 1};path=/;domain=.cian.ru;`;
        document.cookie = `session_region_name=${encodeURIComponent(displayName)};path=/;domain=.cian.ru;`;
        document.cookie = `session_main_town_region_id=${id || mainTownId || 1};path=/;domain=.cian.ru;`;
      } else {
        document.cookie = `session_region_id=${id || 0};path=/;domain=.cian.ru;`;
        document.cookie = `session_region_name=${encodeURIComponent(displayName)};path=/;domain=.cian.ru;`;
        document.cookie = `session_main_town_region_id=${id || mainTownId || 0};path=/;domain=.cian.ru;`;
      }

      location.replace(`${baseHost}${path}`);
    } else {
      /* Отсутствие baseHost - признак Всей России */
      const host = location.host.replace(/^[^.]+\./g, 'www.');

      document.cookie = `content_is_russia=1;path=/;domain=.cian.ru;`;
      document.cookie = `session_region_id=${id};path=/;domain=.cian.ru;`;
      document.cookie = `session_region_name=${encodeURIComponent(displayName)};path=/;domain=.cian.ru;`;
      document.cookie = `session_main_town_region_id=${id};path=/;domain=.cian.ru;`;
      location.replace(`${location.protocol}//${host}${path}`);
    }
  };

  return (
    <ModalWindow
      open={config.regionsShown}
      onClose={() => dispatch(toggleRegions(false))}
      header={
        <Header
          inputValue={inputValue}
          suggests={getSuggests()}
          loading={regions.status === ERegionsStatus.Loading}
          onChangeInputValue={setInputValue}
          onSelectRegion={handleSelectRegion}
          onSubmitRegion={handleSubmitRegion}
        />
      }
      content={
        <>
          <Tabs regions={getTabsRegions()} onClick={handleSelectRegion} />
          <List regions={regionsList} onClick={handleSelectRegion} activeRegion={currentRegion} />
        </>
      }
      width={1179}
      height={'100%'}
      size="M"
      fixed={true}
    />
  );
};

export const Regions = connect((state: { config: IConfig; regions: IRegions }) => ({
  regions: state.regions,
  config: state.config,
}))(RegionsComponent);
